import { EventSystem } from "./EventSystem";

export type VersionedLocalStorageObject = {
    value: any;
    version: number;
};

const allProperties: LocalStorageProperty[] = [];

export function resetAllLocalStorageProperties() {
    allProperties.forEach((x) => x.reset());
}

export class LocalStorageProperty {
    constructor(
        private readonly _eventManager: EventSystem,
        public readonly name: string,
        public readonly version: number,
        private readonly eventName: string | undefined = undefined,
        private readonly defaultValue: any | undefined = undefined
    ) {
        allProperties.push(this);
        if (this.eventName === undefined) {
            this.eventName = `${name}-changed`;
        }
    }

    public set(value: any) {
        window.localStorage.setItem(
            this.name,
            JSON.stringify({
                value,
                version: this.version,
            } as VersionedLocalStorageObject)
        );

        if (this.eventName) {
            this._eventManager.raiseEvent(this.eventName, value);
        }
    }

    public get() {
        const valStr = window.localStorage.getItem(this.name);
        if (valStr) {
            const val = JSON.parse(valStr) as VersionedLocalStorageObject;
            if (val && val.version === this.version) {
                return val.value;
            }
        }
        return this.defaultValue;
    }

    public reset() {
        window.localStorage.removeItem(this.name);
        if (this.eventName) {
            this._eventManager.raiseEvent(this.eventName, this.defaultValue);
        }
    }
}
